export default {
    "contact.title": "Contactez-nous",
    "contact.seo_description": "Une question ? Notre équipe est à votre disposition pour vous aider dans votre préparation à l'examen de citoyenneté.",
    "contact.hero.title": "Contactez-nous",
    "contact.hero.subtitle": "Une question sur notre application ? Besoin d'aide pour votre préparation ? Notre équipe est là pour vous accompagner.",
    "contact.nav.back": "Retour",

    "contact.info.email.title": "Email",
    "contact.info.email.response": "Temps de réponse typique : 24-48 heures",
    "contact.info.address.title": "Adresse",
    "contact.info.address.value": "Saguenay, Québec, Canada",
    "contact.info.phone.title": "Téléphone",
    "contact.info.phone.hours": "(Lun-Ven, 9h-17h EST)",
    "contact.info.others.title": "Autres moyens de nous contacter",

    "contact.form.name.label": "Nom complet",
    "contact.form.name.placeholder": "Votre nom",
    "contact.form.email.label": "Email",
    "contact.form.email.placeholder": "votre@email.com",
    "contact.form.message.label": "Message",
    "contact.form.message.placeholder": "Comment pouvons-nous vous aider ?",
    "contact.form.submit": "Envoyer le message",
    "contact.form.sending": "Envoi en cours...",
    "contact.form.error": "Une erreur est survenue lors de l'envoi du message.",

    "contact.success.title": "Message envoyé !",
    "contact.success.desc": "Merci de nous avoir contactés. Notre équipe vous répondra dans les plus brefs délais.",
    "contact.success.cta": "Envoyer un autre message",

    "contact.footer.copyright": "© 2025 CitoyenPro. Tous droits réservés."
};
